import React, {Component} from 'react';
import PropTypes from 'prop-types';
import isEmpty from "lodash/isEmpty";
import {ChampionTab, CardContainer,UserCard} from "./styles";
import { ImageUrl } from '../../utils/constants';
import { NameInitials } from "../Manager/styles";
import {getInitials} from '../../utils/methods'
class ChampionSectionV2 extends Component {

  showUsersCard = (WellnessChampionsData) => (
    WellnessChampionsData.map((data, index) => (
      <UserCard key={index}>
        {
          data?.profile_image !== "profile-Image/default.png" ? ( <div className="image"> <img src={`${ImageUrl}/${data.profile_image}`} alt={data.name} /> </div> ):
            <div className='image'><NameInitials isSize="24px" isWidth="80px" isHeight="80px" id="name-initials">{getInitials(data?.name)}</NameInitials></div> 
        }
        <div className='name'>{data.name}</div>
        <div className='department'>{data.department||"NA"}</div>
        <div className='location'>{data.location||"NA"}</div>
        <div className='wellnes-wrap'>
          {data && data?.interests.slice(0, 5).map((item, index) => (
            <img src={ImageUrl + "/" + item.interest_icon} alt="no-image" key={index}/>
          ))}
        </div>
        <div className='points'>Wellness Points : {data.total_wellness_point?data.total_wellness_point:"0"}</div>
      </UserCard>
    ))
  );

  WellnessChampionsDashboard = (WellnessChampionsData) => (
    <div>
      {isEmpty(WellnessChampionsData) ?
        <CardContainer>
          <h3>No wellness champions found</h3>
        </CardContainer> : null}
      <CardContainer style={{ gap:"20px 31px", marginBottom:"20px"}}>
        {isEmpty(WellnessChampionsData) ? '' : this.showUsersCard(WellnessChampionsData)}
      </CardContainer>
    </div>
  );

  render() {
    const { wellnessChampions } = this.props;
    return(
      <ChampionTab style={{width:"1246px",margin:"auto"}}>
        { this.WellnessChampionsDashboard(wellnessChampions)}
      </ChampionTab>
    );
  }
}

ChampionSectionV2.propTypes = {
  wellnessChampions: PropTypes.array,
};

export default ChampionSectionV2;